module.exports = __webpack_public_path__ + "static/media/email.9ef733b6.svg";